import api from '@/api';
import { saveParamsToQuery } from '@/utils/helpers';

let currentTicketListRequest = null;

const contracts = {
  namespaced: true,

  state() {
    return {
      isLoading: true,
      search: '',
      type: '',
      onlyMyOffers: false,
      archive: false,
      workTypeId: '',
      publicationDateStart: '',
      publicationDateEnd: '',
      contractorId: '',
      list: {
        contracts: [],
        pageCount: 0,
        page: 0,
      },
    };
  },

  mutations: {
    setSearch(state, search) {
      state.search = search;
    },
    setType(state, value) {
      state.type = value;
    },
    setPage(state, page) {
      state.list.page = page;
    },
    setArchive(state, value) {
      state.archive = value;
    },
    setWorkTypeId(state, value) {
      state.workTypeId = value;
    },
    setContractorId(state, value) {
      state.contractorId = value;
    },
    setPublicationDate(state, value) {
      if (value.includes(' - ')) {
        const [startDate, endDate] = value.split(' - ');
        state.publicationDateStart = startDate;
        state.publicationDateEnd = endDate;
        return;
      }
      state.publicationDateStart = value;
      state.publicationDateEnd = '';
    },
    setOnlyMyOffers(state, onlyMyOffers) {
      state.onlyMyOffers = onlyMyOffers;
    },
    changeLoading(state, status) {
      state.isLoading = status;
    },
    setList(state, data) {
      state.list = { ...data };
    },
  },

  actions: {
    async setSearch({ commit, dispatch }, search) {
      commit('setSearch', search);
      commit('setPage', 1);
      await dispatch('loadList');
    },
    async setPage({ commit, dispatch }, page) {
      commit('setPage', page);
      await dispatch('loadList');
    },
    async loadList({
      state, commit, rootState, rootGetters,
    }) {
      commit('changeLoading', true);

      try {
        if (currentTicketListRequest) {
          return;
        }
        const { isLoggedIn } = rootState.user;
        const role = rootGetters['user/getPriorityRole']('contractor');

        if (!role && isLoggedIn) {
          return;
        }

        const params = {};

        // Формируем параметры запроса, удаляем пустые ключи фильтров
        Object.entries({
          page: state.list.page,
          name: state.search,
          type: state.type,
          onlyMyOffers: state.onlyMyOffers,
          archive: state.archive,
          workTypeId: state.workTypeId,
          publicationDateStart: state.publicationDateStart,
          publicationDateEnd: state.publicationDateEnd,
          contractorId: state.contractorId,
        }).forEach(([key, value]) => {
          if (typeof value === 'number') {
            params[key] = value;
            return;
          }
          if (typeof value === 'object' && value !== null && Object.keys(value).length) {
            params[key] = value;
            return;
          }
          if (value) {
            params[key] = value;
          }
        });
        params.pageSize = isLoggedIn ? 10 : 4;
        if (api.contractWorks[role] !== undefined) {
          currentTicketListRequest = api.contractWorks[role].list(params);
          const result = await currentTicketListRequest;

          saveParamsToQuery({ page: params.page, search: params.search });
          commit('setList', {
            ...result,
            contracts: result.contracts,
          });
          currentTicketListRequest = null;
        } else {
          commit('setList', { result: { contracts: [], page: 1, pageCount: 1 } });
        }
      } catch (e) {
        currentTicketListRequest = null;
        console.log(e);
      } finally {
        commit('changeLoading', false);
      }
    },
  },
};

export default contracts;
